<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Dados cadastrais</h6>
        </d-col>
        <d-col cols="12" lg="8" class="text-right" v-if="cost">
          <delete-button :item-id="cost.id" :delete-event="DELETE_COST" />
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <cost-form ref="costForm"/>
            <d-row>
              <d-col cols="12">
                <div class="control__button">
                  <d-button @click="save" class="btn-primary">Salvar</d-button>
                  <loader v-if="loading" :fullPage="false" class="ml-4"/>
                </div>
              </d-col>
            </d-row>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <confirmation-modal
      :cancel="close"
      :confirm="confirmation.deleteMethod"
      :title="confirmation.title"
      :message="confirmation.message"/>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import DeleteButton from '_common/ui/DeleteButton.vue';
import EntityDeleteMixin from '_common/mixins/EntityDeleteMixin';
import CostForm from './CostForm.vue';
import {
  _SAVE_COST_SUCCESS_,
  _DELETE_COST_,
} from './CostModel';

export default {
  name: 'service-page',
  mixins: [EntityDeleteMixin],
  props: {
    cost: {
      type: Object,
      default: null,
    },
  },
  components: {
    Loader,
    CostForm,
    DeleteButton,
    ConfirmationModal,
  },
  data() {
    return {
      loading: false,
      confirmation: {
        title: 'Confirme exclusão de produto',
        message: 'Tem certeza que deseja excluir esse produto?',
        deleteMethod: this.deleteRow,
      },
      selectedObject: null,
      DELETE_COST: _DELETE_COST_,
      redirectPath: '/admin/custos/lista/1',
      successMessage: 'Custo deletado com sucesso',
      emitEvent: null,
    };
  },
  computed: {},
  methods: {
    save() {
      this.$refs.costForm.save();
      Events.$on(_SAVE_COST_SUCCESS_, cost => {
        this.$router.push(`/admin/custos/${cost.id}`);
      });
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_DELETE_COST_, costId => {
      this.confirmation = {
        title: 'Confirme exclusão de custo',
        message: 'Tem certeza que deseja excluir este custo?',
        deleteMethod: this.deleteRow,
      };
      this.selectedObject = costId;
    });
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
